import { render, staticRenderFns } from "./dstr-sign-verify.vue?vue&type=template&id=1aea2652&scoped=true"
import script from "./dstr-sign-verify.vue?vue&type=script&lang=js"
export * from "./dstr-sign-verify.vue?vue&type=script&lang=js"
import style0 from "./dstr-sign-verify.vue?vue&type=style&index=0&id=1aea2652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aea2652",
  null
  
)

export default component.exports